

































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection, MixinQueryRouter} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryMonthResponse from '@/model/response/DeliveryMonthResponse'
import DeliveryMonthRequest from '@/model/request/DeliveryMonthRequest'
import FilterDeliveryMonth from '@/components/filters/FilterDeliveryMonth.vue'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryMonth.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryMonth},
})
export default class ReportsDeliveryMonthView extends Mixins(MixinFilter)  {
  filter = new DeliveryMonthRequest()
  collection = new PageCollection(DeliveryMonthResponse, this.filter, 10)

  AppConfig = AppConfig

  async downloadData(xlsx: boolean) {
    if (!xlsx) {
        const csv = new PageCollection(DeliveryMonthResponse, this.filter, null, null)

        const fetch = async () => await csv.search()
        await $.await.run(fetch, 'download')
        csv.downloadCsv(snakeCase($.t('view.reports.deliveryMonth.title')))
    } else {
        await $.await.run(() => Helper.downloadXlsx(
          $.t('view.reports.deliveryMonth.title'),
          new DeliveryMonthResponse().$endpoint,
          this.filter,
          DeliveryMonthResponse,
          'DeliveryMonthResponse',
          ), 'download')
    }
  }
}
